import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import BaseComponent from './BaseComponent';
import Style from './Curriculum.cssmodule.less';
import { clickButton, updateItemIndex } from '../../actions/Modal';
import { MediaStatusTypes } from '../../Constants';
import Media from '../../components/CommonSet/Media';
import 'simplebar';
import 'simplebar/dist/simplebar.css';

class CurriculumStudyHint extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.isNewHintType = !!props.item.hint;
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'CURRICULUM_HINT');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(this.Style.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    createHtmlContent(contnet) {
        let contentHTML = '';

        if (contnet) {
            contentHTML = contnet.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>').append(this.createRenderView(block)).html();
            });
        }

        return contentHTML;
    }

    createContent() {
        let view = null;
        const { item = {} } = this.props;
        if (item.content || (item.hint && item.hint.contents)) {
            view = (
                <div className={classNames(this.Style.cell, this.Style.txt)}>
                    <div
                        className={this.Style.inner}
                        data-simplebar
                        style={
                            item.hint &&
                            item.hint.contents && {
                                wordBreak: 'break-word',
                                padding: '10px 10px 50px 0',
                                marginLeft: 0,
                                height: '100%',
                                overflowY: 'auto',
                                width: '100%',
                            }
                        }
                        dangerouslySetInnerHTML={{
                            __html: this.createHtmlContent(
                                item.content || item.hint.contents
                            ),
                        }}
                    />
                </div>
            );
        }
        return view;
    }

    createMediaView() {
        let view = null;
        const { item = {} } = this.props;
        const { media = {}, hint } = item;
        const { category, checkScript } = media;
        if (hint && hint.image) {
            const filename = hint.image.filename;
            const path = `/uploads/${filename.slice(0, 2)}/${filename.slice(
                2,
                4
            )}/${filename}.${hint.image.imageType}`;
            view = (
                <div
                    className={`${this.Style.cell} ${this.Style.thmb}`}
                    style={
                        hint && hint.contents
                            ? { width: '264px' }
                            : { verticalAlign: 'middle' }
                    }
                >
                    <img src={path} style={{ padding: 20 }} />
                </div>
            );
        } else if (category && category !== MediaStatusTypes.NONE) {
            view = (
                <div className={`${this.Style.cell} ${this.Style.thmb}`}>
                    <Media
                        className={classNames(
                            this.Style.media,
                            Style[category],
                            this.Style.inner
                        )}
                        media={media}
                        params={{ type: 'course' }}
                        checkScript={checkScript}
                        option={{
                            width: 384,
                            height: 354,
                        }}
                    />
                </div>
            );
        }
        return view;
    }

    render() {
        const {
            itemIndex = 0,
            maxIndex = 0,
            actions = {},
            item = {},
        } = this.props;
        const { updateItemIndex } = actions;
        const { title = '' } = item;
        const isNotMedia = item.hint;
        return (
            <div>
                <div className={this.Style.popup_wrap}>
                    <div
                        className={`${this.Style.pop_header} ${this.Style.hint_header}`}
                    >
                        <strong className={this.Style.sjt}>{title}</strong>
                        <span className={this.Style.step}>
                            {itemIndex + 1}/{maxIndex}
                        </span>
                    </div>
                    <div className={this.Style.pop_cont}>
                        <div className={this.Style.scroll_box}>
                            {this.isNewHintType ? (
                                <div
                                    className={this.Style.txt_img_box}
                                    style={{
                                        background: 'rgba(214, 233, 244, 0.3)',
                                        border: '1px #aac5d5',
                                    }}
                                >
                                    {this.createMediaView()}
                                    {this.createContent()}
                                </div>
                            ) : (
                                <div className={this.Style.txt_img_box}>
                                    {this.createContent()}
                                    {this.createMediaView()}
                                </div>
                            )}
                        </div>
                        <span
                            className={classNames(
                                this.Style.btn_arr,
                                this.Style.prev,
                                { [this.Style.disabled]: itemIndex === 0 }
                            )}
                            onClick={() =>
                                updateItemIndex(Math.max(0, itemIndex - 1))
                            }
                        >
                            이전
                        </span>
                        <span
                            className={classNames(
                                this.Style.btn_arr,
                                this.Style.next,
                                {
                                    [this.Style.disabled]:
                                        itemIndex === maxIndex - 1,
                                }
                            )}
                            onClick={() =>
                                updateItemIndex(
                                    Math.min(itemIndex + 1, maxIndex - 1)
                                )
                            }
                        >
                            다음
                        </span>
                    </div>
                    <span
                        className={this.Style.pop_close}
                        onClick={(e) => this.handleButtonClick('close')}
                    >
                        팝업닫기
                    </span>
                </div>
            </div>
        );
    }
}

CurriculumStudyHint.displayName = 'CurriculumStudyHint';
CurriculumStudyHint.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(undefined, mapDispatchToProps)(CurriculumStudyHint);



// WEBPACK FOOTER //
// ./components/ModalSet/CurriculumStudyHint.js